
import { BasePage } from './base';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertPopoverPage } from './alert-popover/alert-popover';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [
    AlertPopoverPage,
    BasePage,
  ],
  entryComponents: [
    AlertPopoverPage
  ]
})
export class BasePageModule {}
